import React from 'react';
import {
  DEBRIEF_PARTICIPANT,
  DEBRIEF_TITLE_BY_PARTICIPANT
} from 'features/sendouts/components/drawers/SendoutInterviewDebriefDrawer/SendoutInterviewDebriefDrawer.constants';

import { DebriefSection } from './components/DebriefSection';

export const DebriefingCallTabContent = ({ onEditDebrief, onViewDebrief }) => (
  <>
    <DebriefSection
      onEdit={() => onEditDebrief(DEBRIEF_PARTICIPANT.Employer)}
      onView={() => onViewDebrief(DEBRIEF_PARTICIPANT.Employer)}
      title={DEBRIEF_TITLE_BY_PARTICIPANT[DEBRIEF_PARTICIPANT.Employer]}
    />
    <DebriefSection
      onEdit={() => onEditDebrief(DEBRIEF_PARTICIPANT.Candidate)}
      onView={() => onViewDebrief(DEBRIEF_PARTICIPANT.Candidate)}
      title={DEBRIEF_TITLE_BY_PARTICIPANT[DEBRIEF_PARTICIPANT.Candidate]}
    />
  </>
);
